(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('RptCompendiumMessage', RptCompendiumMessage);

    RptCompendiumMessage.$inject = ['$resource'];

    function RptCompendiumMessage($resource) {
        var resourceUrl = 'api/rpt-compendium-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
